import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./css/main.css";
import "react-alice-carousel/lib/alice-carousel.css";

ReactDOM.render(<App />, document.getElementById("root"));
